import { render } from "./workflowcard-popover.vue?vue&type=template&id=595a44ea"
import script from "./workflowcard-popover.vue?vue&type=script&lang=js"
export * from "./workflowcard-popover.vue?vue&type=script&lang=js"

import "./workflowcard-popover.vue?vue&type=style&index=0&id=595a44ea&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__